var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11.1055 1.41406L20.2979 10.6065L11.1055 19.7988","stroke":"currentColor","strokeWidth":"3.5","key":0}),React.createElement("path",{"d":"M1.91308 10.6065L20.2979 10.6065","stroke":"currentColor","strokeWidth":"3.5","key":1})]);
}

ArrowRight.defaultProps = {"width":"23","height":"22","viewBox":"0 0 23 22","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
